module.exports = __webpack_public_path__ + "static/media/mgm_interior1.e520d00d.jpg";